<template>
    <div style="min-width: 700px;" v-loading="loading">
      <el-table
        ref="tableData"
        :stripe="stripe"
        :height="height"
        border
        show-summary
        :max-height="maxHeight"
        header-row-class-name="table-list-header"
        row-class-name="table-list-row"
        :size="tableSize"
        :data="data"
        @selection-change="handleSelectionChange"
        @current-change="handleTableCurrentChange"
        @row-click="handleTableRowClick"
        v-bind="otherConfig">
        <template v-for="(p, index) in columns" >
          <!-- 选择框 -->
          <el-table-column
            v-if="p.selection"
            type="selection"
            width="p.width ? p.width : 50"
            :fixed="p.fixed"
            align="center"
            :key="index"
          ></el-table-column>
          <!-- 序号 -->
          <el-table-column
            v-else-if="p.type"
            type="index"
            width="p.width ? p.width : 80"
            :label="p.label"
            :index="p.indexMethod"
            :key="index"
          ></el-table-column>
          <!-- 多级表头 -->
          <el-table-column
            v-else-if="p.multi"
            align="center"
            :label="p.label"
            :key="index"
          >
            <el-table-column
              v-for="(child, childIndex) in p.children"
              :key="childIndex"
              v-bind="child"
            >
            </el-table-column>
          </el-table-column>
          <!-- 自定义内容 -->
          <el-table-column
           v-else-if="p.slot"
           :label="p.label"
           :width="p.width"
           align="center"
           :key="index">

           <template slot-scope="scope">
            <slot v-if="p.slot"  :name="p.slot"  :row="scope.row" :index="scope.$index"></slot>   
           </template>

          <!-- <slot
            :name="p.slot"
            :fixed="p.fixed"
            >
          </slot> -->
          </el-table-column>
          <!-- 常规字段 -->
          <el-table-column
            v-else-if="p.minWidth &&!p.width"
            :prop="p.prop"
            align="center"
            :min-width="p.minWidth"
            :label="p.label"
            :key="index"
          ></el-table-column>
          <el-table-column
            v-else
            :prop="p.prop"
            align="center"
            :width="p.width"
            :label="p.label"
            :key="index"
          ></el-table-column>
        </template>
      </el-table>
      <!-- eslint-disable -->
      <el-pagination
        v-if="isPaginationShow && pagination.total"
        class="opagination mt12"
        background
        layout="sizes, prev, pager, next"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </template>

<script>
export default {
  name: 'comTable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    isPaginationShow: {
      type: Boolean,
      default: true
    },
    showSummary: {
      type: Boolean,
      default: true
    },
    tableSize: {
      type: String,
      default: 'small'
    },
    stripe: {
      type: Boolean,
      default: true
    },
    otherConfig: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    height: {
      type: String | Number,
      default:''
    }
  },
  data () {
    return {
      
      maxHeight:'1000'
    }
  },
  methods: {
    // 切换页码
    handleCurrentChange () {
      this.$emit('getData')
    },
    // 切换每页条数
    handleSizeChange (value) {
      // current-page和 page-size都支持 .sync修饰符，用了.sync修饰符，就不需要手动给 this.pagination赋值了
      this.pagination.size = value
      this.$emit('getData')
    },
    // 切换选择
    handleSelectionChange (val) {
      this.$emit('changeSelection', val)
    },
    // 单选
    handleTableCurrentChange (currentRow) {
      this.$emit('changeCurrent', currentRow)
    },
    // 点击行
    handleTableRowClick (currentRow) {
      this.$emit('rowClick', currentRow)
    }
  },
  watch: {
    data () {
      // 重新请求数据时 table滚动到顶部
      this.$refs.tableData.$refs.bodyWrapper.scrollTop = 0
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs.tableData.doLayout();
    })
  },
}
</script>

<style lang="scss" scoped>
.opagination{
  height: 50px;
  min-width: 700px;
  display: flex;
  align-items: center;
}
</style>
